/*
 * @Author: your name
 * @Date: 2021-05-19 14:28:59
 * @LastEditTime: 2021-07-20 16:39:44
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \ha-crer\src\components\Login\footerMessage.js
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, IconButton, Typography } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button/index';
import { useHistory } from 'react-router-dom';
import ResourceIcon from 'assets/images/resources_icon.png';

const useStyles = makeStyles((theme) => ({
    contanier: {
        padding: theme.spacing(2),
        paddingBottom: 0,
    },
    title: {
        fontSize: 15,
        fontWeight: 'bold',
        borderBottom: '1px solid #ddd',
        marginBottom: theme.spacing(1),
        paddingBottom: 2,
    },
    text: {
        fontSize: 13,
        marginBottom: theme.spacing(1),
    },
    marginTop: {
        marginTop: theme.spacing(1),
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
    resourceIcon: {
        width: '100%',
        height: 'auto',
    },
}));

const FooterMessage = (props) => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Grid container className={classes.contanier} alignItems="flex-end" justify="center">
            <Grid container item xs={12} justify="space-around" wrap="nowrap" alignItems="flex-end">
                <Grid container wrap="nowrap">
                    <Grid className={classes.marginTop}>
                        <Grid container className={classes.text}>
                            Supported Browsers - Chrome or Firefox in Windows OS/Mac OS
                        </Grid>
                        <Grid container className={classes.text}>
                            Optimized Screen resolution - 1920 x 1080 or 1280 x 1024
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container justify="center" style={{ maxWidth: 148 }}>
                    <IconButton onClick={() => history.push('/guide')} style={{ width: '100%', height: '100%' }}>
                        <img className={classes.resourceIcon} src={ResourceIcon} alt="resource" />
                    </IconButton>
                    <CustomButton
                        onClick={() => {
                            history.push('/guide');
                        }}
                        style={{ marginBottom: 16 }}
                    >
                        Research Application Resources
                    </CustomButton>
                </Grid>
                <Grid container>
                    {/* <Grid container className={classes.marginTop}>
                        <Grid container alignItems="baseline" justify="flex-end">
                            <Typography className={classes.title}>User Manual and Quick User Guide</Typography>
                            <Grid className={classes.marginLeft}>
                                <CustomButton
                                    onClick={() => {
                                        history.push('/guide');
                                    }}
                                    variant="outlined"
                                >
                                    [Click here]
                                </CustomButton>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        className={classes.marginTop}
                        alignItems="baseline"
                        wrap="nowrap"
                        justify="flex-end"
                    >
                        <Typography className={classes.title}>Enquiries </Typography>
                        <Typography className={classes.text} style={{ marginLeft: 16 }}>
                            (Mon - Fri, 09:00 - 17:30, except Public Holiday)
                        </Typography>
                    </Grid> */}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default FooterMessage;
